import { API_ERROR } from '../constants/editorConfig';
import { UPLOAD_IMAGE_TO_S3 } from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import apiRequest from '../util/apiRequest';
import {
  RESET_CREATE_CONTENT,
  RESET_UPLOAD_IMAGE,
  UPLOAD_IMAGE_ACTION,
} from './createContentActionTypes';

export const uploadImage = (payload = {}, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  let response = {};

  return apiRequest(
    UPLOAD_IMAGE_TO_S3,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ ...payload }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      response = res;
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: UPLOAD_IMAGE_ACTION,
        payload: {
          status,
          response,
        },
      });
    });
};

export const resetImage = () => dispatch => {
  dispatch({
    type: RESET_UPLOAD_IMAGE,
  });
};

export const resetCreateContent = () => dispatch => {
  dispatch({
    type: RESET_CREATE_CONTENT,
  });
};
